"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Entity_1 = require("./Entity");

var utils_1 = require("../utils");

var PolymathError_1 = require("../PolymathError");

var types_1 = require("../types");
/**
 * @hidden
 * Check if a value is of type [[UniqueIdentifiers]]
 */


function isUniqueIdentifiers(identifiers) {
  var securityTokenId = identifiers.securityTokenId,
      stoId = identifiers.stoId,
      index = identifiers.index;
  return typeof securityTokenId === 'string' && typeof stoId === 'string' && typeof index === 'number';
}
/**
 * Used to manage an Investment in a Security Token Offering
 */


var Investment =
/*#__PURE__*/
function (_Entity_1$Entity) {
  _inherits(Investment, _Entity_1$Entity);

  _createClass(Investment, null, [{
    key: "generateId",

    /**
     * Generate the Investment's UUID from its identifying properties
     */
    value: function generateId(_ref) {
      var securityTokenId = _ref.securityTokenId,
          stoId = _ref.stoId,
          index = _ref.index;
      return utils_1.serialize('investment', {
        securityTokenId: securityTokenId,
        stoId: stoId,
        index: index
      });
    }
    /**
     * Unserialize a serialized Investment entity
     *
     * @param serialized - string with Investment entity information
     */

  }, {
    key: "unserialize",
    value: function unserialize(serialized) {
      var unserialized = utils_1.unserialize(serialized);

      if (!isUniqueIdentifiers(unserialized)) {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.InvalidUuid,
          message: 'Wrong Investment ID format'
        });
      }

      return unserialized;
    }
    /**
     * Create an Investment instance
     */

  }]);

  function Investment(params) {
    var _this;

    _classCallCheck(this, Investment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Investment).call(this));
    var securityTokenId = params.securityTokenId,
        securityTokenSymbol = params.securityTokenSymbol,
        stoId = params.stoId,
        address = params.address,
        index = params.index,
        tokenAmount = params.tokenAmount,
        investedFunds = params.investedFunds;
    _this.securityTokenId = securityTokenId;
    _this.securityTokenSymbol = securityTokenSymbol;
    _this.stoId = stoId;
    _this.address = address;
    _this.index = index;
    _this.tokenAmount = tokenAmount;
    _this.investedFunds = investedFunds;
    _this.uid = Investment.generateId({
      securityTokenId: securityTokenId,
      stoId: stoId,
      index: index
    });
    return _this;
  }
  /**
   * Convert entity to a POJO (Plain Old Javascript Object)
   */


  _createClass(Investment, [{
    key: "toPojo",
    value: function toPojo() {
      var uid = this.uid,
          securityTokenId = this.securityTokenId,
          securityTokenSymbol = this.securityTokenSymbol,
          stoId = this.stoId,
          address = this.address,
          index = this.index,
          tokenAmount = this.tokenAmount,
          investedFunds = this.investedFunds;
      return {
        uid: uid,
        securityTokenId: securityTokenId,
        securityTokenSymbol: securityTokenSymbol,
        stoId: stoId,
        address: address,
        index: index,
        tokenAmount: tokenAmount,
        investedFunds: investedFunds
      };
    }
    /**
     * Hydrate the entity
     */

  }, {
    key: "_refresh",
    value: function _refresh(params) {
      var securityTokenSymbol = params.securityTokenSymbol,
          address = params.address,
          investedFunds = params.investedFunds,
          tokenAmount = params.tokenAmount;

      if (securityTokenSymbol) {
        this.securityTokenSymbol = securityTokenSymbol;
      }

      if (address) {
        this.address = address;
      }

      if (investedFunds) {
        this.investedFunds = investedFunds;
      }

      if (tokenAmount) {
        this.tokenAmount = tokenAmount;
      }
    }
  }]);

  return Investment;
}(Entity_1.Entity);

exports.Investment = Investment;